// extracted by mini-css-extract-plugin
export var auto = "_4p-1";
export var spinner = "_4p-0";